import {FC} from 'react'
import {Link} from 'react-router-dom'
import {Clock} from 'jbc-front/components/icons'
import {dateFormat} from 'libs/formatter'
import {TodoList} from 'types/api/todoLists/todoList'
import {Todo, TodoChangeHandler} from './Todo'
import styles from './Timeline.scss'

// @ts-ignore
import {ListItem, ListGroup, ListTitle} from 'components/ListGroup'

/** 日付を持つイベントとリンク */
interface Event {
  type: 'event'
  date: string
  label: string
  link?: {to: string; label: string}
}

/** 手続きとそれに紐付くToDoリスト */
interface Procedure {
  type: 'procedure'
  title: string
  todoLists: (TodoList & {
    todoListNo: number // state.procedureStatuses.current.data.todo_listsのindexと正確に一致させること
  })[]
}

export type TimelineItem = Event | Procedure

interface TimelineProps {
  items: TimelineItem[]
  onTodoChange: TodoChangeHandler
}

/**
 * 時系列に沿ってイベントや手続きToDoを表示するコンポーネント
 */
export const Timeline: FC<TimelineProps> = ({items, onTodoChange}) => (
  <div className={styles.timelineBar}>
    {items.map((item, index) => {
      switch (item.type) {
        case 'event':
          return <EventNode key={index} event={item} />
        case 'procedure':
          return <ProcedureNode key={index} procedure={item} onTodoChange={onTodoChange} />
        default:
          return null
      }
    })}
  </div>
)

interface EventNodeProps {
  event: Event
}

const EventNode: FC<EventNodeProps> = ({event}) => (
  <div className={styles.event}>
    <div className={styles.eventYear}>{dateFormat(event.date, 'YYYY')}</div>
    <div className={styles.eventDate}>{dateFormat(event.date, 'M/D')}</div>
    <div className={styles.timelineDotLine} />
    <div className={styles.timelineDot} />
    <div className={styles.eventCell}>
      <div className={styles.eventCellText}>{event.label}</div>
      {event.link && (
        <Link className={styles.eventCellLinkButton} to={event.link.to}>
          {event.link.label}
        </Link>
      )}
    </div>
  </div>
)

interface ProcedureNodeProps {
  procedure: Procedure
  onTodoChange: TodoChangeHandler
}

const ProcedureNode: FC<ProcedureNodeProps> = ({procedure, onTodoChange}) => (
  <div className={styles.procedure}>
    <div className={styles.timelineDotLine} />
    <div className={styles.timelineDot} />
    <ListTitle>{procedure.title}</ListTitle>
    <ListItem>
      <div className={styles.procedureListGroups}>
        {procedure.todoLists.map(
          (todoList) =>
            todoList.todos &&
            todoList.todos.length > 0 && (
              <ListGroup key={todoList.todoListNo}>
                <ListTitle>
                  <div>
                    {todoList.title}
                    {todoList.due_on && (
                      <span className={styles.procedureDueOn}>
                        <Clock size={16} /> {dateFormat(todoList.due_on, 'MMMDo')}
                      </span>
                    )}
                  </div>
                </ListTitle>
                {todoList.todos.map((todo, todoNo) => (
                  <ListItem key={todoNo}>
                    <Todo onTodoChange={onTodoChange} todoListNo={todoList.todoListNo} todoNo={todoNo} todo={todo} />
                  </ListItem>
                ))}
              </ListGroup>
            )
        )}
      </div>
    </ListItem>
  </div>
)
